import "../Stylesheets/Login/Login.css"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { usersActions } from "../store/user";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import api from "../lib/api";
import useNotify from "../hooks/useNotify";

const Login = ({ setNotification }) => {
    const [formData, setFormData] = useState({ username: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const notify = useNotify(setNotification);

    const auth = (e) => {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        api.post('/users/login', formData)
            .then((res) => {
                notify.success("You are logged in");
                dispatch(usersActions.saveUserData(res.data.data));
                dispatch(usersActions.changeIsLoggedIn(true));
            })
            .catch((err) => {
                dispatch(usersActions.changeIsLoggedIn(false));
                // Read straight off err.response.data.message.en before, which
                // threw a second error and blanked the page whenever the
                // request failed without a response (offline, timeout, 502).
                notify.error(err, "Could not sign in.");
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="login-page-container">
            <div className="login-page-banner" aria-hidden="true">
                <img className="login-banner-logo" src="/static/icons/logo.png" alt="Royal Motors" />
            </div>
            <div className="login-form-container">
                <div className="login-form-inner">
                    <h1 className="login-title">Welcome to Royal Motors</h1>
                    <p className="login-subtitle">Sign in to manage your auction accounts.</p>
                    <form className="login-form" onSubmit={auth}>
                        <div className="form-group">
                            <label htmlFor="login-username">Username</label>
                            <input
                                id="login-username"
                                type="text"
                                className="form-control"
                                name="username"
                                required
                                autoComplete="username"
                                autoFocus
                                value={formData.username}
                                onChange={(e) => setFormData((prev) => ({ ...prev, username: e.target.value }))}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="login-password">Password</label>
                            <div className="password-field">
                                <input
                                    id="login-password"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    required
                                    autoComplete="current-password"
                                    value={formData.password}
                                    onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    onClick={() => setShowPassword((prev) => !prev)}
                                >{showPassword ? <EyeSlash /> : <Eye />}</button>
                            </div>
                        </div>
                        <button className="login-button" type="submit" disabled={loading}>
                            {loading ? <div className="button-loader"></div> : "Log In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login
